import { render } from "./eduReleaseLesson.vue?vue&type=template&id=2a2bf006&scoped=true"
import script from "./eduReleaseLesson.vue?vue&type=script&lang=js"
export * from "./eduReleaseLesson.vue?vue&type=script&lang=js"

import "./eduReleaseLesson.vue?vue&type=style&index=0&id=2a2bf006&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a2bf006"]])

export default __exports__